import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person_outline"}/>
}
